exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.add-case-btn[data-v-768dc365] {\r\n  margin-bottom: 20px;\n}\n.head-img[data-v-768dc365]{\r\n  width: 50px;\n}\n.image[data-v-768dc365]{\r\n  display: none;\n}\r\n", ""]);

// exports
